module.exports = {
  CREATED_BY_IDENTIFIER: {
    TRULY_USER: 'TRULY_USER',
    LIRA_USER: 'LIRA_USER',
    SYSTEM: 'SYSTEM'
  },
  CREATED_BY_IDENTIFIER: {
    TRULY_USER: 'TRULY_USER',
    LIRA_USER: 'LIRA_USER',
    SYSTEM: 'SYSTEM'
  },
  CREATED_BY_IDENTIFIER: {
    TRULY_USER: 'TRULY_USER',
    LIRA_USER: 'LIRA_USER',
    SYSTEM: 'SYSTEM'
  }
};
